import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SkeletonComponent = ({ count = 1, width = 100, ...rest }) => {
	return <Skeleton count={count} width={width} {...rest} />;
};

export default SkeletonComponent;
